import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getIndustryList(params) {
    return request({
        url: '/industry',
        method: 'get',
        params: params
    })
}
/**
 * 添加 / 修改
 * @param {*} params
 */
export function addIndustry(params) {
    return request({
        url: '/industry',
        method: 'post',
        data: params
    })
}
/**
 * 通过id删除
 */
export function deleteIndustry(id) {
    return request({
        url: `/industry/${id}`,
        method: 'delete',
    })
}
/**
 * 查看详情
 */
export function getIndustry(id) {
    return request({
        url: `/industry/${id}`,
        method: 'get'
    })
}
/**
* 修改
* @param {*} params
*/
export function editIndustry(params) {
    return request({
        url: '/industry',
        method: 'put',
        data: params
    })
}